type AdobeEvarType = {
  eVar10: 'productName';
  eVar26: 'productID';
  eVar38: 'formPageName';
  eVar83: 'questionPageTitle';
  eVar84: 'questionIndex';
  eVar85: 'productError';
  eVar86: 'marketplaceError';
  eVar87: 'formSubmitError';
  eVar88: 'formError';
  eVar89: 'nbaId';
  eVar90: 'formDuplicate';
};

export type AnalyticsDataType = {
  pageName: string;
  globalPageName: string;
  productId: string;
  productName: string;
  nbaId: string;
  productError: boolean;
  marketplaceError: boolean;
  questionIndex: number;
  questionPageTitle: string;
  formError: boolean;
  formSubmitError: boolean;
  formDuplicate: boolean;
};

const eVarDataMap: Record<keyof AnalyticsDataType, keyof AdobeEvarType> = {
  productName: 'eVar10',
  productId: 'eVar26',
  pageName: 'eVar38',
  questionPageTitle: 'eVar83',
  questionIndex: 'eVar84',
  productError: 'eVar85',
  marketplaceError: 'eVar86',
  formSubmitError: 'eVar87',
  formError: 'eVar88',
  nbaId: 'eVar89',
  formDuplicate: 'eVar90',
  globalPageName: undefined,
};

export const setAnalyticsData = (analyticsData: Partial<AnalyticsDataType>) => {
  const mapper = (v, k) => {
    if (window.s && eVarDataMap[k]) window.s[eVarDataMap[k]] = v;
  };
  // The following sets the eVar object structure on window.s
  new Map(Object.entries(analyticsData)).forEach(mapper); // JS Map
  window.dataLayer = analyticsData;

  if (window.s && analyticsData.globalPageName) window.s.pageName = analyticsData.globalPageName;
  if (window.s && typeof window.s.t === 'function') window.s.t();
};

export const setAnalyticsPageName = (pageName: string) => {
  if (window.s) window.s.pageName = pageName;
};

export const setCustomLink = ({ linkType = 'e', linkDescription = '' } = {}) => {
  if (window.s && typeof window.s.tl === 'function') window.s.tl(true, linkType, linkDescription);
};
